// Deliberately no hardcoded UTC offset here — daylight saving shifts each of
// these (except Hawaii and UTC) by an hour twice a year, so a static offset is
// wrong for roughly half the year no matter what value is chosen. The current,
// correct offset for each `id` is computed at render time via moment-timezone
// (see LocationFormComponent), which already knows each zone's real DST rules.
export const UtcListConstant = [
    {value: 'Eastern Time', id: 'America/New_York'},
    {value: 'Central Time', id: 'America/Chicago'},
    {value: 'Mountain Time', id: 'America/Denver'},
    {value: 'Pacific Time', id: 'America/Los_Angeles'},
    {value: 'Alaska Time', id: 'America/Anchorage'},
    {value: 'Hawaii Time', id: 'Pacific/Honolulu'},
    {value: 'UTC', id: 'UTC'},
];
